<template lang="html">
  <div class="values-container mt-5">
    <div class="values-bg">
      <img src="../../assets/img/values-bg.svg" alt="">
    </div>
    <div class="values-text">
      <h2 class="blue-text">Our Core Values</h2>
      <div class="single-value mt-5">
        <h4>Make healthcare easier</h4>
        <p>We want to improve healthcare. We want to prevent disease and unnecessary pain. We want to give individuals access to better solutions — solutions that are faster, easier, more comfortable, and more affordable. Ultimately, we aim to help everyone transition from reactive healthcare to proactive wellness.</p>
      </div>
      <div class="single-value mt-5">
        <h4>Think Fresh</h4>
        <p>We are Creators. We reimagine things and then turn our visions into tangible realities. For us, innovation goes hand in hand with simplicity, functionality, and beauty.</p>
      </div>
      <div class="single-value mt-5">
        <h4>Trust Science</h4>
        <p>Science is at the core of what we do, and we always use scientific approaches and adhere to medical standards. We believe that high-quality scientific data can help us all better understand health and wellness and we are committed to being a trusted source of information. Your health is too important to do otherwise.</p>
      </div>
      <div class="single-value mt-5">
        <h4>Ebrace Technology</h4>
        <p>We use technology as a way to push the boundaries of what’s possible and create innovative products. Technology enables us to multiply any effort: build for one, reach everyone.</p>
      </div>
      <div class="single-value mt-5">
        <h4>Love what you do</h4>
        <p>We’re passionate about our mission and want to bring the best we’ve got to everything we do. By turning our passion into creativity and resourcefulness, we strive to raise our own standards and become better every day.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
  .values-container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
    grid-gap: 1em;
  }

  .values-bg {
    display: none;
  }
  .values-text {
    grid-column: 2/11;
    grid-row: 1/13;
    z-index: 3;
  }

  @media (min-width: 768px) {
    .values-bg {
      display: block;
      grid-column: 1/13;
      grid-row: 6;
      opacity: .7;
      margin-left: -3em;
      z-index: 2;
    }
  }

  @media (min-width: 1200px) {
    .values-bg {
      display: block;
      grid-column: 2/10;
      grid-row: 9;
      opacity: .7;
      margin-left: -3em;
      z-index: 2;
    }
    .values-text {
      padding: 5em 0 3em 0;
      grid-column: 3/8;
    }
  }

</style>
